import { IOfferCardContext } from '../offer-card';
import { TLabelType, IOnlineDealSettings, TNewbuildingLabelTexts } from '../types/newbuildingLabel';

export type TCommonContext = Pick<IOfferCardContext, 'newbuildingLabel'>;

export const getLabelType = (
  newbuildingId: number,
  onlineDealSettings: IOnlineDealSettings[],
  isFromDeveloper: boolean,
  isFromLeadFactory: boolean,
): TLabelType | null => {
  let type: TLabelType | null = null;

  if (isFromDeveloper) {
    type = 'builderOnline';
  }

  if (isFromLeadFactory) {
    type = 'consultantOnline';
  }

  onlineDealSettings.forEach(regionSettings => {
    if (regionSettings.newBuildingIds.includes(newbuildingId) && isFromDeveloper) {
      type = 'onlineDeal';
    }
  });

  return type;
};

export const getNewbuildingLabel = (
  {newbuildingLabel}: TCommonContext,
  isFromDeveloper: boolean,
  isLeadFactory: boolean,
  newbuildingId: number,
): TNewbuildingLabelTexts | null => {
  if (!newbuildingLabel) {
    return null;
  }
  const type = getLabelType(newbuildingId, newbuildingLabel.onlineDeal, isFromDeveloper, isLeadFactory);

  return type
    ? {
      labelText: newbuildingLabel.indicatorTexts[type],
      tooltipText: newbuildingLabel.infoTexts[type].text,
      tooltipTitle: newbuildingLabel.infoTexts[type].title,
    }
    : null;
};
